import { withMessageInputContext } from "@/context/MessageInputContext";
import { withSessionProvider } from "@/context/SessionContext";
import { OnboardingSlot } from "@/onboarding";
import {
  TemplateCopyPromptDialog,
  TemplateCopyPromptProvider,
  useTemplateCopyPromptDefer,
} from "@/template-prompt";
import React from "react";
import { HomeSurface } from "./HomeSurface";

/**
 * Browser-style home page (canvas-centric `/` behind the `newHomePage` flag):
 * the unscoped `HomeSurface` — greeting + composer above a Recents / Canvases /
 * Chats / Starred browser. The workspace detail page renders the same surface
 * scoped to one workspace. The finish-onboarding CTA lives inside the browser,
 * not here; the home onboarding slot below is what a never-started user sees.
 *
 * A template-signup prompt outranks the welcome dialog for the one view that
 * spends it: `TemplateCopyPromptProvider` latches the deferral, so onboarding
 * returns on the next home view without any server state changing.
 */
const HomePageInner: React.FC = withSessionProvider(() => {
  return (
    <TemplateCopyPromptProvider>
      <title>{import.meta.env.VITE_DEFAULT_APP_TITLE}</title>
      <HomeSurface />
      <HomePageDialogs />
    </TemplateCopyPromptProvider>
  );
});

/** Inside the provider — the defer hook can't run in the component rendering it. */
function HomePageDialogs() {
  return (
    <>
      <OnboardingSlot
        surface="home"
        suppressed={useTemplateCopyPromptDefer()}
      />
      <TemplateCopyPromptDialog />
    </>
  );
}

export const HomePage = withMessageInputContext(HomePageInner);
